import templateUrl from 'emun.salesrep/designapproval-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import _ from "underscore";
import ServiceBus from 'servicestack/service-bus'

class DesignApprovalOrdersController {
    constructor($rootScope) { 
        const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		var context = $ctrl.context || 'rep';
		var repFilter = "";
		if (context != 'executive') {
			var filterType = "SalesRepID";
			if (context == 'manager') {
				filterType = 'ManagerId';
			}
			repFilter = "&" + filterType + "=" + $ctrl.rep.id;
		}
		$ctrl.logQuery = new AutoQuery({
			url: 'QueryApprovalRequests.json',
			autoLoad: true,
			pageSize: 10000,
			onLoaded: function(args) {
				$ctrl.logs = _.indexBy(args.results, 'cart');
				$ctrl.orders = new AutoQuery({
					url: 'QueryCartsJoin.json?Status=On Hold&ReasonCode=Design Approval' + repFilter,
					orderBy: '-OrderedOn',
					autoLoad: true,
					pageSize: 10,
					scrollTop: false,
					onLoaded: function(args) {
						args.results.forEach(function(res) {
							res.approvalRequested = false;
							if ($ctrl.logs[res.id]) {
								res.approvalRequested = true;
								res.approvalEmail = $ctrl.logs[res.id].email;
								res.approvalRequestSent = $ctrl.logs[res.id].lastSentOn;
							}
						});
					}
				})
			}
		});
    }
	resend(cartId) {
		let $ctrl = this;
		$ctrl.bus.send('ResendApprovalRequest.json', {cartId: cartId}).then(function() {
			$ctrl.orders.load(true);
		});
	}
}

let DesignApprovalOrders = {
    bindings: {
        repId: '@',
        context: '@',
        rep: '<'
    },
    controller: DesignApprovalOrdersController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default DesignApprovalOrders